import firebase from 'firebase'
var config = {
    apiKey: "AIzaSyC2LXqDY-_3WuoFNAUUhlthjDIp7zUafgE",
    authDomain: "gui-builder-601c1.firebaseapp.com",
    databaseURL: "https://gui-builder-601c1.firebaseio.com",
    projectId: "gui-builder-601c1",
    storageBucket: "gui-builder-601c1.appspot.com",
    messagingSenderId: "850501466599"
};

export const uid="";
// Required for side-effects
require("firebase/firestore");

firebase.initializeApp(config);
firebase.auth().onAuthStateChanged(function(user) {
    if (user) {
        // User is signed in.
        var isAnonymous = user.isAnonymous;
         this.uid = user.uid;
        // ...
    } else {
        // User is signed out.
        // ...
    }
    // ...
});
export const db = firebase.firestore();
/*
export const loadMeta=() => {
    db.collection("project").where(firebase.firestore.FieldPath.documentId(), "==", "ONfZRb51fVNIL9kHNdaU").get().then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
            meta = doc.data();
        });
    });
};
*/
export const auth = () => {
    firebase.auth().signInAnonymously().catch(function(error) {
        var errorCode=error.code;
        var errorMessage=error.message;
    }).then(()=>{
       // loadMeta();
    });
};



export default firebase;





// WEBPACK FOOTER //
// ./src/firebase/firebase.js